import { action, observable } from 'mobx';
import { SerializedData, Store } from 'bernie-core';
import { FlightsStepIndicator } from '__generated__/api';
import ErrorAnalytics = FlightsStepIndicator.ErrorAnalytics;

export class StepIndicatorStore extends Store {
  @observable public journeyContinuationId: string;
  @observable public errorAnalytics: ErrorAnalytics;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  @action
  public setJourneyContinuationIdInStepIndicator = (journeyContinuationId?: string) => {
    this.journeyContinuationId = journeyContinuationId;
  };
}
